import { render, staticRenderFns } from "./vx.vue?vue&type=template&id=a41c8134"
import script from "./vx.vue?vue&type=script&lang=js"
export * from "./vx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports